
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/welcome",
      function () {
        return require("private-next-pages/[locale]/welcome/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/welcome"])
      });
    }
  